<div class="auth">
  <section class="hero" aria-label="Kluby Fit">
    <div class="hero__media" aria-hidden="true"></div>
    <div class="hero__scrim" aria-hidden="true"></div>
    <div class="hero__inner">
      <img class="hero__logo" src="assets/images/kluby-fit-logo.png" alt="" />
    </div>
  </section>

  <!-- Panel derecho: acceso al sistema -->
  <section class="panel" aria-label="Acceso al sistema">
    <mat-card class="login-card">
      <img class="card__brand" [src]="brandLogoUrl" [alt]="brandName" />

      <div class="card__head">
        <span class="card__eyebrow">Acceso al sistema</span>
        <h2 class="card__title">Bienvenido de vuelta</h2>
        <p class="card__subtitle">Ingresa tus credenciales para entrar al panel de control.</p>
      </div>

      <form #myForm="ngForm" (ngSubmit)="login()" class="form" [attr.aria-busy]="loading" novalidate>
        <div class="alert" role="alert" *ngIf="errorMessage">
          <mat-icon aria-hidden="true">error_outline</mat-icon>
          <span>{{ errorMessage }}</span>
        </div>

        <mat-form-field appearance="outline" class="field">
          <mat-label>Usuario</mat-label>
          <mat-icon matPrefix aria-hidden="true">person_outline</mat-icon>
          <input
            matInput
            #usernameInput
            name="username"
            autocomplete="username"
            spellcheck="false"
            required
            [(ngModel)]="username"
            #usernameCtrl="ngModel"
          />
          <mat-error *ngIf="usernameCtrl.hasError('required')">Ingresa tu usuario</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="field">
          <mat-label>Contraseña</mat-label>
          <mat-icon matPrefix aria-hidden="true">lock_outline</mat-icon>
          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            name="password"
            autocomplete="current-password"
            required
            [(ngModel)]="password"
            #passwordCtrl="ngModel"
            (keyup)="checkCapsLock($event)"
            (keydown)="checkCapsLock($event)"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="field__toggle"
            (click)="hidePassword = !hidePassword"
            [attr.aria-label]="hidePassword ? 'Mostrar contraseña' : 'Ocultar contraseña'"
            [attr.aria-pressed]="!hidePassword"
          >
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error *ngIf="passwordCtrl.hasError('required')">Ingresa tu contraseña</mat-error>
          <mat-hint class="field__hint" *ngIf="capsLockOn">
            <mat-icon aria-hidden="true">keyboard_capslock</mat-icon>
            Mayúsculas activadas
          </mat-hint>
        </mat-form-field>

        <button mat-flat-button color="primary" type="submit" class="cta" [disabled]="loading">
          <mat-spinner class="cta__spinner" *ngIf="loading" diameter="20" strokeWidth="2"></mat-spinner>
          <span class="cta__label">{{ loading ? 'Validando acceso' : 'Iniciar sesión' }}</span>
        </button>
      </form>

      <p class="card__foot">
        <mat-icon aria-hidden="true">verified_user</mat-icon>
        Sesión protegida. Se cierra automáticamente tras 4 horas de inactividad.
      </p>
    </mat-card>
    <p class="panel__footer">
      Kluby Fit · Gestión de gimnasios<span *ngIf="appVersion !== 'dev'"> · {{ appVersion }}</span>
    </p>
  </section>
</div>
